import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/web.dom-collections.iterator";
import _typeof from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/typeof";
import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module mention/mentionui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import clickOutsideHandler from '@ckeditor/ckeditor5-ui/src/bindings/clickoutsidehandler';
import { keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
import env from '@ckeditor/ckeditor5-utils/src/env';
import Rect from '@ckeditor/ckeditor5-utils/src/dom/rect';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import ContextualBalloon from '@ckeditor/ckeditor5-ui/src/panel/balloon/contextualballoon';
import TextWatcher from '@ckeditor/ckeditor5-typing/src/textwatcher';
import MentionsView from './ui/mentionsview';
import DomWrapperView from './ui/domwrapperview';
import MentionListItemView from './ui/mentionlistitemview';
var VERTICAL_SPACING = 3;
/**
 * The mention UI feature.
 *
 * @extends module:core/plugin~Plugin
 */

var MentionUI =
/*#__PURE__*/
function (_Plugin) {
  _inherits(MentionUI, _Plugin);

  _createClass(MentionUI, null, [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'MentionUI';
    }
    /**
     * @inheritDoc
     */

  }]);

  function MentionUI(editor) {
    var _this;

    _classCallCheck(this, MentionUI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MentionUI).call(this, editor));
    /**
     * The mention view.
     *
     * @type {module:mention/ui/mentionsview~MentionsView}
     * @private
     */

    _this._mentionsView = _this._createMentionView();
    /**
     * Stores mention feeds configurations.
     *
     * @type {Map<String, Object>}
     * @private
     */

    _this._mentionsConfigurations = new Map();
    editor.config.define('mention', {
      feeds: []
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MentionUI, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      /**
       * The contextual balloon plugin instance.
       *
       * @private
       * @member {module:ui/panel/balloon/contextualballoon~ContextualBalloon}
       */

      this._balloon = editor.plugins.get(ContextualBalloon); // Key listener that handles navigation in mention view.

      editor.editing.view.document.on('keydown', function (evt, data) {
        if (isHandledKey(data.keyCode) && _this2._isUIVisible) {
          data.preventDefault();
          evt.stop(); // Required for Enter key overriding.

          if (data.keyCode == keyCodes.arrowdown) {
            _this2._mentionsView.selectNext();
          }

          if (data.keyCode == keyCodes.arrowup) {
            _this2._mentionsView.selectPrevious();
          }

          if (data.keyCode == keyCodes.enter || data.keyCode == keyCodes.tab || data.keyCode == keyCodes.space) {
            _this2._mentionsView.executeSelected();
          }

          if (data.keyCode == keyCodes.esc) {
            _this2._hideUIAndRemoveMarker();
          }
        }
      }, {
        priority: 'highest'
      }); // Required to override the Enter key.
      // Close the dropdown upon clicking outside of the plugin UI.

      clickOutsideHandler({
        emitter: this._mentionsView,
        activator: function activator() {
          return _this2._isUIVisible;
        },
        contextElements: [this._balloon.view.element],
        callback: function callback() {
          return _this2._hideUIAndRemoveMarker();
        }
      });
      var feeds = editor.config.get('mention.feeds');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = feeds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var mentionDescription = _step.value;
          var feed = mentionDescription.feed;
          var marker = mentionDescription.marker;

          if (!marker || marker.length != 1) {
            /**
             * The marker must be a single character.
             *
             * Correct markers: `'@'`, `'#'`.
             *
             * Incorrect markers: `'$$'`, `'[@'`.
             *
             * See {@link module:mention/mention~MentionConfig}.
             *
             * @error mentionconfig-incorrect-marker
             */
            throw new CKEditorError('mentionconfig-incorrect-marker: The marker must be provided and it must be a single character.', null);
          }

          var minimumCharacters = mentionDescription.minimumCharacters || 0;
          var feedCallback = typeof feed == 'function' ? feed.bind(this.editor) : createFeedCallback(feed);

          var watcher = this._setupTextWatcherForFeed(marker, minimumCharacters);

          var itemRenderer = mentionDescription.itemRenderer;
          var definition = {
            watcher: watcher,
            marker: marker,
            feedCallback: feedCallback,
            itemRenderer: itemRenderer
          };

          this._mentionsConfigurations.set(marker, definition);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(MentionUI.prototype), "destroy", this).call(this); // Destroy created UI components as they are not automatically destroyed (see ckeditor5#1341).


      this._mentionsView.destroy();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_createMentionView",

    /**
     * Creates the {@link #_mentionsView}.
     *
     * @private
     * @returns {module:mention/ui/mentionsview~MentionsView}
     */
    value: function _createMentionView() {
      var _this3 = this;

      var locale = this.editor.locale;
      var mentionsView = new MentionsView(locale);
      this._items = new Collection();
      mentionsView.items.bindTo(this._items).using(function (data) {
        var item = data.item,
            marker = data.marker;
        var listItemView = new MentionListItemView(locale);

        var view = _this3._renderItem(item, marker);

        view.delegate('execute').to(listItemView);
        listItemView.children.add(view);
        listItemView.item = item;
        listItemView.marker = marker;
        listItemView.on('execute', function () {
          mentionsView.fire('execute', {
            item: item,
            marker: marker
          });
        });
        return listItemView;
      });
      mentionsView.on('execute', function (evt, data) {
        var editor = _this3.editor;
        var model = editor.model;
        var item = data.item;
        var marker = data.marker;
        var mentionMarker = editor.model.markers.get('mention'); // Create a range on matched text.

        var end = model.createPositionAt(model.document.selection.focus);
        var start = model.createPositionAt(mentionMarker.getStart());
        var range = model.createRange(start, end);

        _this3._hideUIAndRemoveMarker();

        editor.execute('mention', {
          mention: item,
          text: item.text,
          marker: marker,
          range: range
        });
        editor.editing.view.focus();
      });
      return mentionsView;
    }
    /**
     * Returns item renderer for the marker.
     *
     * @private
     * @param {String} marker
     * @returns {Function|null}
     */

  }, {
    key: "_getItemRenderer",
    value: function _getItemRenderer(marker) {
      var _this$_mentionsConfig = this._mentionsConfigurations.get(marker),
          itemRenderer = _this$_mentionsConfig.itemRenderer;

      return itemRenderer;
    }
    /**
     * Returns a promise that resolves with autocomplete items for a given text.
     *
     * @param {String} marker
     * @param {String} feedText
     * @return {Promise<module:mention/mention~MentionFeedItem>}
     * @private
     */

  }, {
    key: "_getFeed",
    value: function _getFeed(marker, feedText) {
      var _this$_mentionsConfig2 = this._mentionsConfigurations.get(marker),
          feedCallback = _this$_mentionsConfig2.feedCallback;

      return Promise.resolve().then(function () {
        return feedCallback(feedText);
      });
    }
    /**
     * Registers a text watcher for the marker.
     *
     * @private
     * @param {String} marker
     * @param {Number} minimumCharacters
     * @returns {module:typing/textwatcher~TextWatcher}
     */

  }, {
    key: "_setupTextWatcherForFeed",
    value: function _setupTextWatcherForFeed(marker, minimumCharacters) {
      var _this4 = this;

      var editor = this.editor;
      var watcher = new TextWatcher(editor.model, createTestCallback(marker, minimumCharacters));
      watcher.on('matched', function (evt, data) {
        var selection = editor.model.document.selection;
        var focus = selection.focus; // The text watcher listens only to changed range in selection - so the selection attributes are not yet available
        // and you cannot use selection.hasAttribute( 'mention' ) just yet.
        // See https://github.com/ckeditor/ckeditor5-engine/issues/1723.

        var hasMention = focus.textNode && focus.textNode.hasAttribute('mention');
        var nodeBefore = focus.nodeBefore;

        if (hasMention || nodeBefore && nodeBefore.is('text') && nodeBefore.hasAttribute('mention')) {
          _this4._hideUIAndRemoveMarker();

          return;
        }

        var feedText = getFeedText(marker, data.text);
        var matchedTextLength = marker.length + feedText.length; // Create a marker range.

        var start = focus.getShiftedBy(-matchedTextLength);
        var end = focus.getShiftedBy(-feedText.length);
        var markerRange = editor.model.createRange(start, end);
        var mentionMarker;

        if (editor.model.markers.has('mention')) {
          mentionMarker = editor.model.markers.get('mention');
        } else {
          mentionMarker = editor.model.change(function (writer) {
            return writer.addMarker('mention', {
              range: markerRange,
              usingOperation: false,
              affectsData: false
            });
          });
        }

        _this4._getFeed(marker, feedText).then(function (feed) {
          _this4._items.clear();

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = feed[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var feedItem = _step2.value;
              var item = _typeof(feedItem) != 'object' ? {
                id: feedItem,
                text: feedItem
              } : feedItem;

              _this4._items.add({
                item: item,
                marker: marker
              });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (_this4._items.length) {
            _this4._showUI(mentionMarker);
          } else {
            _this4._hideUIAndRemoveMarker();
          }
        });
      });
      watcher.on('unmatched', function () {
        _this4._hideUIAndRemoveMarker();
      });
      return watcher;
    }
    /**
     * Shows the mentions balloon. If the panel is already visible, it will reposition it.
     *
     * @private
     */

  }, {
    key: "_showUI",
    value: function _showUI(markerMarker) {
      if (this._isUIVisible) {
        // Update balloon position as the mention list view may change its size.
        this._balloon.updatePosition(this._getBalloonPanelPositionData(markerMarker, this._mentionsView.position));
      } else {
        this._balloon.add({
          view: this._mentionsView,
          position: this._getBalloonPanelPositionData(markerMarker, this._mentionsView.position),
          withArrow: false,
          singleViewMode: true
        });
      }

      this._mentionsView.position = this._balloon.view.position;

      this._mentionsView.selectFirst();
    }
    /**
     * Hides the mentions balloon and removes the 'mention' marker from the markers collection.
     *
     * @private
     */

  }, {
    key: "_hideUIAndRemoveMarker",
    value: function _hideUIAndRemoveMarker() {
      // Remove the mention view from balloon before removing marker - it is used by balloon position target().
      if (this._balloon.hasView(this._mentionsView)) {
        this._balloon.remove(this._mentionsView);
      }

      if (this.editor.model.markers.has('mention')) {
        this.editor.model.change(function (writer) {
          return writer.removeMarker('mention');
        });
      } // Make the last matched position on panel view undefined so the #_getBalloonPanelPositionData() method will return all positions
      // on the next call.


      this._mentionsView.position = undefined;
    }
    /**
     * Renders a single item in the autocomplete list.
     *
     * @private
     * @param {module:mention/mention~MentionFeedItem} item
     * @param {String} marker
     * @returns {module:ui/button/buttonview~ButtonView|module:mention/ui/domwrapperview~DomWrapperView}
     */

  }, {
    key: "_renderItem",
    value: function _renderItem(item, marker) {
      var editor = this.editor;
      var view;
      var label = item.id;

      var renderer = this._getItemRenderer(marker);

      if (renderer) {
        var renderResult = renderer(item);

        if (typeof renderResult != 'string') {
          view = new DomWrapperView(editor.locale, renderResult);
        } else {
          label = renderResult;
        }
      }

      if (!view) {
        var buttonView = new ButtonView(editor.locale);
        buttonView.label = label;
        buttonView.withText = true;
        view = buttonView;
      }

      return view;
    }
    /**
     * Creates a position options object used to position the balloon panel.
     *
     * @param {module:engine/model/markercollection~Marker} mentionMarker
     * @param {String|undefined} preferredPosition The name of the last matched position name.
     * @returns {module:utils/dom/position~Options}
     * @private
     */

  }, {
    key: "_getBalloonPanelPositionData",
    value: function _getBalloonPanelPositionData(mentionMarker, preferredPosition) {
      var _this5 = this;

      var editor = this.editor;
      var editing = this.editor.editing;
      var domConverter = editing.view.domConverter;
      var mapper = editing.mapper;
      return {
        target: function target() {
          var modelRange = mentionMarker.getRange(); // Target the UI to the model selection range - the marker has been removed so probably the UI will not be shown anyway.
          // The logic is used by ContextualBalloon to display another panel in the same place.

          if (modelRange.start.root.rootName == '$graveyard') {
            modelRange = editor.model.document.selection.getFirstRange();
          }

          var viewRange = mapper.toViewRange(modelRange);
          var rangeRects = Rect.getDomRangeRects(domConverter.viewRangeToDom(viewRange));
          return rangeRects.pop();
        },
        limiter: function limiter() {
          var view = _this5.editor.editing.view;
          var viewDocument = view.document;
          var editableElement = viewDocument.selection.editableElement;

          if (editableElement) {
            return view.domConverter.mapViewToDom(editableElement.root);
          }

          return null;
        },
        positions: getBalloonPanelPositions(preferredPosition)
      };
    }
  }, {
    key: "_isUIVisible",

    /**
     * Returns true when {@link #_mentionsView} is in the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon} and it is
     * currently visible.
     *
     * @readonly
     * @protected
     * @type {Boolean}
     */
    get: function get() {
      return this._balloon.visibleView === this._mentionsView;
    }
  }], [{
    key: "requires",
    get: function get() {
      return [ContextualBalloon];
    }
  }]);

  return MentionUI;
}(Plugin); // Returns the balloon positions data callbacks.
//
// @param {String} preferredPosition
// @returns {Array.<module:utils/dom/position~Position>}


export { MentionUI as default };

function getBalloonPanelPositions(preferredPosition) {
  var positions = {
    // Positions the panel to the southeast of the caret rectangle.
    'caret_se': function caret_se(targetRect) {
      return {
        top: targetRect.bottom + VERTICAL_SPACING,
        left: targetRect.right,
        name: 'caret_se'
      };
    },
    // Positions the panel to the northeast of the caret rectangle.
    'caret_ne': function caret_ne(targetRect, balloonRect) {
      return {
        top: targetRect.top - balloonRect.height - VERTICAL_SPACING,
        left: targetRect.right,
        name: 'caret_ne'
      };
    },
    // Positions the panel to the southwest of the caret rectangle.
    'caret_sw': function caret_sw(targetRect, balloonRect) {
      return {
        top: targetRect.bottom + VERTICAL_SPACING,
        left: targetRect.right - balloonRect.width,
        name: 'caret_sw'
      };
    },
    // Positions the panel to the northwest of the caret rect.
    'caret_nw': function caret_nw(targetRect, balloonRect) {
      return {
        top: targetRect.top - balloonRect.height - VERTICAL_SPACING,
        left: targetRect.right - balloonRect.width,
        name: 'caret_nw'
      };
    }
  }; // Returns only the last position if it was matched to prevent the panel from jumping after the first match.

  if (positions.hasOwnProperty(preferredPosition)) {
    return [positions[preferredPosition]];
  } // By default return all position callbacks.


  return [positions.caret_se, positions.caret_sw, positions.caret_ne, positions.caret_nw];
} // Creates a RegExp pattern for the marker.
//
// Function has to be exported to achieve 100% code coverage.
//
// @param {String} marker
// @param {Number} minimumCharacters
// @returns {RegExp}


export function createRegExp(marker, minimumCharacters) {
  var numberOfCharacters = minimumCharacters == 0 ? '*' : "{".concat(minimumCharacters, ",}");
  var openAfterCharacters = env.features.isRegExpUnicodePropertySupported ? '\\p{Ps}\\p{Pi}"\'' : '\\(\\[{"\'';
  var mentionCharacters = env.features.isRegExpUnicodePropertySupported ? '\\p{L}\\p{N}' : 'a-zA-ZÀ-ž0-9'; // The pattern consists of 3 groups:
  // - 0 (non-capturing): Opening sequence - start of the line, space or an opening punctuation character like "(" or "\"",
  // - 1: The marker character,
  // - 2: Mention input (taking the minimal length into consideration to trigger the UI),
  //
  // The pattern matches up to the caret (end of string switch - $).
  //               (0:      opening sequence       )(1:  marker   )(2:                typed mention                 )$

  var pattern = "(?:^|[ ".concat(openAfterCharacters, "])([").concat(marker, "])([_").concat(mentionCharacters, "]").concat(numberOfCharacters, ")$");
  return new RegExp(pattern, 'u');
} // Creates a test callback for the marker to be used in the text watcher instance.
//
// @param {String} marker
// @param {Number} minimumCharacters
// @returns {Function}

function createTestCallback(marker, minimumCharacters) {
  var regExp = createRegExp(marker, minimumCharacters);
  return function (text) {
    return regExp.test(text);
  };
} // Creates a text matcher from the marker.
//
// @param {String} marker
// @returns {Function}


function getFeedText(marker, text) {
  var regExp = createRegExp(marker, 0);
  var match = text.match(regExp);
  return match[2];
} // The default feed callback.


function createFeedCallback(feedItems) {
  return function (feedText) {
    var filteredItems = feedItems // Make the default mention feed case-insensitive.
    .filter(function (item) {
      // Item might be defined as object.
      var itemId = typeof item == 'string' ? item : String(item.id); // The default feed is case insensitive.

      return itemId.toLowerCase().includes(feedText.toLowerCase());
    }) // Do not return more than 10 items.
    .slice(0, 10);
    return Promise.resolve(filteredItems);
  };
} // Checks if a given key code is handled by the mention UI.
//
// @param {Number}
// @returns {Boolean}


function isHandledKey(keyCode) {
  var handledKeyCodes = [keyCodes.arrowup, keyCodes.arrowdown, keyCodes.enter, keyCodes.tab, keyCodes.space, keyCodes.esc];
  return handledKeyCodes.includes(keyCode);
}